import { render, staticRenderFns } from "./icon-templates.vue?vue&type=template&id=7b851e79"
import script from "./icon-templates.vue?vue&type=script&lang=js"
export * from "./icon-templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports